import * as Yup from 'yup'
import { getSS } from '../helpers'
import './methods.js'

const paymentMethodDirectDebit = getSS('membership').payment_method === 'DirectDebit'
const formType = window.KEW.collections.membership_form[0].form_type

const homepage = Yup.object().shape({
  selected_membership: Yup
    .object(),
  dob: Yup
    .string()
    .when('selected_membership.value', {
      is: 'youngpersons',
      then: Yup
        .string()
        .validateDob('dob')
    })
    .when('selected_membership.value', {
      is: 'youngpersonsplus',
      then: Yup
        .string()
        .validateDob('dob')
    })
})



const ExistingMembershipNumber = formType === 'renewal' || formType === 'upgrade' ? {
  existing_membership_number: Yup
  .string()
  .required("Please enter your membership number")
  .matches(/^MM\d{8}$|^M\d{6}$|^W\d{7}$|^120\d{9}$/, "Please enter a valid membership number")
} : {
  existing_membership_number: Yup
  .string()
}
const PreviousVisitDate = formType === 'daypass' ? {
  previous_visit_date: Yup
    .string().required("Please select a date")
} : {
  previous_visit_date: Yup
  .string()
}
const PreviousVisitTicketNumber = formType === 'daypass' ? {
  previous_visit_ticket_number: Yup
    .string()
    .when('ticketPurchasedAt', {
      is: 'kew',
      then: Yup
        .string()
        .required("Please enter you ticket reference number")
        .min(5, "Please enter a valid number")
        .max(5, "Please enter a valid number")
    })
    .when('ticketPurchasedAt', {
      is: 'online',
      then: Yup
        .string()
        .required("Please enter you ticket reference number")
        .min(10, "Please enter a valid number")
        .max(10, "Please enter a valid number")
    })
} : {
  previous_visit_ticket_number: Yup
    .string()
}



const getDetailsValidation = (membershipType) =>  {

    const jointMembershipTypes = [
    'jointfriend',
    'jointfamfriend',
    'wakehurst_jointfriend',
    'wakehurst_jointfamfriend',
    'jointfriendplus',
    'jointfamfriendplus',
    'wakehurst_family_2adults',
    'wakehurst_family_2adultsplus',
    'wakehurst_jointadult',
    'wakehurst_jointadultplus'
  ]

  const secondNamedAdult = jointMembershipTypes.includes(membershipType) ? {
    // second_named_adult_salutation: Yup
    //   .string()
    //   .sepiaValidate('second_named_adult_salutation')
    //   .required('Please enter their title'),
    second_named_adult_first_name: Yup
      .string()
      .sepiaValidate('second_named_adult_first_name')
      .required('Please enter their first name'),
    second_named_adult_last_name: Yup
      .string()
      .sepiaValidate('second_named_adult_last_name')
      .required('Please enter their last name'),
    second_named_adult_email: Yup
      .string()
      .sepiaValidate('second_named_adult_email')
      .required('Please enter their email address'),
  } : {}


  return Yup.object().shape({
    optins_post: Yup
      .boolean(),
    optins_email: Yup
      .boolean(),
    optins_phone: Yup
      .boolean(),
    salutation: Yup
      .string()
      .sepiaValidate('salutation'),
    first_name: Yup
      .string()
      .sepiaValidate('first_name'),
    last_name: Yup
      .string()
      .sepiaValidate('last_name'),
    email: Yup
      .string()
      .sepiaValidate('email'),
    phone: Yup
      .string()
      .sepiaValidatePhone(),
    ...ExistingMembershipNumber,
    ...PreviousVisitDate,
    ...PreviousVisitTicketNumber,
    ...secondNamedAdult,
    address_search: Yup
      .string(),
    organisation: Yup
      .string(),
    address_1: Yup
      .string()
      .sepiaValidate('address_1'),
    address_2: Yup
      .string(),
    address_3: Yup
      .string(),
    town_city: Yup
      .string()
      .sepiaValidate('town_city'),
    county_state: Yup
      .string(),
    postcode: Yup
      .string()
      .sepiaValidatePostcode(),
    country: Yup
      .string()
  })
}


const payment = Yup.object().shape({
  optins_giftaid: Yup
    .boolean(),
})

const BankAccountName = paymentMethodDirectDebit ? {bank_account_account_name: Yup.string().required("Please enter the name of the account holder").sepiaValidate('bank_account_account_name')} : {bank_account_account_name: Yup.string()}
const BankAccountNumber = paymentMethodDirectDebit ? {bank_account_account_number: Yup.string().required("Please enter the account number").sepiaValidate('bank_account_account_number')} : {bank_account_account_number: Yup.string()}
const BankAccountSortCode = paymentMethodDirectDebit ? {bank_account_sort_code: Yup.string().required("Please enter the sort code").sepiaValidate('bank_account_sort_code')} : {bank_account_sort_code: Yup.string()}

const payment_regular = Yup.object().shape({
  ...BankAccountName,
  ...BankAccountNumber,
  bank_account_account_number_redacted: Yup
    .string(),
  ...BankAccountSortCode
})

const validation = { homepage, getDetailsValidation, payment, payment_regular }

export default validation